import Typography from '../components/Typography';
import Layout from '../components/Layout';
import { useNavigate } from '@reach/router';

const Card = ({ cardNumber = '#CZ-4829', className = '' }) => {
  // Image assets from Figma (valid for 7 days)
  const imgImage =
    'https://www.figma.com/api/mcp/asset/09407213-6b29-4723-8e7b-fe634204d7c9';
  const imgIcon =
    'https://www.figma.com/api/mcp/asset/f1f87506-2b6f-4683-8df3-09c39491cd88';

  return (
    <div
      className={`content-stretch flex flex-col items-center justify-center overflow-clip pb-[83.26px] pt-[83.27px] px-[24px] relative rounded-[20px] shadow-[0px_15px_35px_-5px_rgba(26,35,126,0.25)] w-full ${className}`}
      style={{
        backgroundImage:
          'linear-gradient(137.15296404540624deg, rgb(120, 39, 138) 0%, rgb(0, 104, 145) 100%)',
      }}
      data-name="Background+Shadow"
      data-node-id="953:33268"
    >
      {/* Top-left Chip Overlay */}
      <div
        className="absolute backdrop-blur-[2px] bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.1)] border-solid h-[32px] left-[24px] rounded-[6px] top-[24px] w-[48px]"
        data-name="Overlay+Border+OverlayBlur"
        data-node-id="953:33286"
      />

      {/* Background Image Overlay */}
      <div
        className="absolute bg-size-[67px_100px] bg-top-left inset-0 mix-blend-overlay opacity-10"
        data-name="Image"
        data-node-id="953:33287"
        style={{ backgroundImage: `url('${imgImage}')` }}
      />

      {/* Central Logo and Icon */}
      <div
        className="content-stretch flex items-center pr-[0.01px] relative shrink-0"
        data-name="Container"
        data-node-id="953:33269"
      >
        <div
          className="content-stretch flex flex-col items-start mr-[-0.01px] relative shrink-0"
          data-name="Heading 1"
          data-node-id="953:33270"
        >
          <Typography
            weight="bold"
            color="white"
            className="text-[30px] tracking-[-0.75px] whitespace-nowrap leading-[36px] lowercase"
            data-node-id="953:33271"
          >
            cauze
          </Typography>
        </div>
        <div
          className="content-stretch flex flex-col items-start mr-[-0.01px] pl-[8px] relative shrink-0"
          data-name="Margin"
          data-node-id="953:33272"
        >
          <div
            className="content-stretch flex flex-col items-start relative shrink-0"
            data-name="Container"
            data-node-id="953:33273"
          >
            <div className="flex items-center justify-center relative shrink-0">
              <div className="-scale-y-100 flex-none">
                <div
                  className="h-[36px] relative w-[30px]"
                  data-name="Icon"
                  data-node-id="953:33274"
                >
                  <img
                    alt="Cauze"
                    className="block max-w-none size-full"
                    src={imgIcon}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom-left Dots */}
      <div
        className="absolute bottom-[24px] content-stretch flex items-start left-[24px]"
        data-name="Container"
        data-node-id="953:33276"
      >
        <div
          className="bg-[rgba(255,255,255,0.4)] rounded-[9999px] shrink-0 size-[8px]"
          data-name="Overlay"
          data-node-id="953:33277"
        />
        <div
          className="content-stretch flex flex-col h-[8px] items-start pl-[4px] relative shrink-0 w-[12px]"
          data-name="Margin"
          data-node-id="953:33278"
        >
          <div
            className="bg-[rgba(255,255,255,0.4)] rounded-[9999px] shrink-0 size-[8px]"
            data-name="Overlay"
            data-node-id="953:33279"
          />
        </div>
        <div
          className="content-stretch flex flex-col h-[8px] items-start pl-[4px] relative shrink-0 w-[12px]"
          data-name="Margin"
          data-node-id="953:33280"
        >
          <div
            className="bg-[rgba(255,255,255,0.4)] rounded-[9999px] shrink-0 size-[8px]"
            data-name="Overlay"
            data-node-id="953:33281"
          />
        </div>
        <div
          className="content-stretch flex flex-col h-[8px] items-start pl-[4px] relative shrink-0 w-[12px]"
          data-name="Margin"
          data-node-id="953:33282"
        >
          <div
            className="bg-[rgba(255,255,255,0.4)] rounded-[9999px] shrink-0 size-[8px]"
            data-name="Overlay"
            data-node-id="953:33283"
          />
        </div>
      </div>

      {/* Bottom-right Card Number */}
      <div
        className="absolute bottom-[20px] content-stretch flex flex-col items-start min-w-[67.22000122070312px] right-[24px]"
        data-name="Container"
        data-node-id="953:33284"
      >
        <Typography
          className="text-[12px] text-[rgba(255,255,255,0.6)] tracking-[1.2px] whitespace-nowrap leading-[16px] font-agenda"
          data-node-id="953:33285"
        >
          {cardNumber}
        </Typography>
      </div>
    </div>
  );
};

const LoadCard = () => {
  const navigate = useNavigate();
  return (
    <Layout className="pt-24 px-6">
      <Card />
      <div className="mb-8" />
      <Typography className="mb-4 text-[24px] text-center" weight="bold">
        Load this Cauze Card
      </Typography>
      <Typography className="mb-28 text-[16px] text-center">
        Add any amount to give the gift of giving to someone you care about.
      </Typography>
      <button
        className="cz-btn-brand w-full mb-6"
        onClick={() => navigate(`/gift-redeem/funds`)}
      >
        Load Card
      </button>
      <Typography
        color="orange"
        className="text-center text-[14px]"
        weight="bold"
      >
        What's a Cauze Card?
      </Typography>
    </Layout>
  );
};

export default LoadCard;
